module.exports = __webpack_public_path__ + "static/media/LogicLever6_1_continue_2.d8fbb0bd.png";